export default {
  getReserva: state => id => {
    const localId = parseInt(id, 10)
    let reservaFound = state.reservas.find(reserva => reserva.id === localId)
    if (!reservaFound) {
      reservaFound = state.minhasReservas.find(reserva => reserva.id === localId)
    }
    return reservaFound
  },
}
